// @ts-nocheck
import { currentScreenAndDialog } from ".."
import { handleReactor, ReactorReturnType } from "./reactor"
import { _RenderTracking, addTrackedPath, isTracking, paths } from "./tracker"
export let actionTracking = {
  actionRunning: false,
  lastActionName: undefined,
  canceled: false,
}
let cumulatedPathsFromProxify = new Set()

export function createDeepProxy(target) {
  const preproxy = new WeakMap()
  //let ignore = false
  function makeHandler(path) {
    return {
      get(target, key, receiver) {
        if (key !== "toJSON" && isTracking()) {
          let isArray = Array.isArray(target)
          let value = target[key]
          if (
            typeof key === "symbol" ||
            (typeof value !== "function" &&
              !(isArray && "push;pop;splice;unshift;shift;".indexOf(key) > -1)) //&&
            //key !== "toJSON"
          ) {
            let pathToTrack
            if (typeof key === "symbol" || (isArray && key === "length")) {
              pathToTrack = [...path].join(".")
            } else {
              pathToTrack = [...path, key].join(".")
            }
            // if (
            //   window.dbg === true &&
            //   pathToTrack.indexOf("U_FillingWeight") > -1 &&
            //   key === "hasFocus"
            // ) {
            //   debugger
            // }
            addTrackedPath(pathToTrack)
          }
        }
        return Reflect.get(...arguments)
      },
      //traps the Object.keys(...)
      ownKeys(target) {
        //   if (ignore) {
        //     return Reflect.ownKeys(target)
        //   }
        //   // if (window.dbg) {
        //   //   debugger
        //   // }

        let ownKeys = Reflect.ownKeys(target)
        if (isTracking()) {
          ownKeys.forEach((m) => {
            let pathToTrack = [...path, m].join(".")
            addTrackedPath(pathToTrack)
          })
        }
        return ownKeys
      },
      // traps (in operator)
      has(target, key) {
        if (isTracking()) {
          if (!Array.isArray(target)) {
            Reflect.ownKeys(target).forEach((m) => {
              let pathToTrack = [...path, m].join(".")
              addTrackedPath(pathToTrack)
            })
          }
        }
        return Reflect.has(...arguments)
      },
      set(target, key, value, receiver) {
        if (value !== null && typeof value === "object" && key !== "_files") {
          if (!preproxy.has(value)) {
            value = proxify(value, [...path, key])
          }
        } else {
          // we don't want stuff to rerender/reactors called if the primitive value didn't change
          if (target[key] === value) {
            return true
          }
        }

        let isArray = Array.isArray(target)
        let pathToTrackParent
        let dotpath = [...path].join(".")
        if (typeof target === "object" && target[key] === undefined) {
          pathToTrackParent = dotpath
        }

        let startScreenUpdate = false
        if (pathToTrackParent) {
          let rres = handleReactor(pathToTrackParent, value)
          if (rres?.cancel) {
            return false
          }
          if (rres?.newValue) {
            value = rres.newValue
          }
          if (!cumulatedPathsFromProxify.has(pathToTrackParent)) {
            // if (pathToTrackParent === "ovl.screens.nav") {
            //   console.trace()
            // }
            startScreenUpdate = true
            cumulatedPathsFromProxify.add(pathToTrackParent)
          }
        }

        let pathToTrack = `${dotpath}.${key}`
        if (isArray && key === "length") {
          pathToTrack = dotpath
        }

        // if (pathToTrack.indexOf("enrichedInput.LotNum") > -1) {
        //   console.log("from tracker ", pathToTrack, key, value)
        //   debugger
        // }

        // if (pathToTrack.indexOf(".OvlSysState.fnFeedback") > -1) {
        //   console.log("from tracker ", pathToTrack, key, value)
        //   debugger
        // }

        // if (pathToTrack.indexOf(".TOTPDigit1.convertedValue") > -1) {
        //   console.log("from tracker ", pathToTrack, key, value)
        //   console.trace()
        // }
        // if (pathToTrack.indexOf(".TOTPDigit1.value") > -1) {
        //   console.log("from tracker ", pathToTrack, key, value)
        //   console.trace()
        // }

        // if (
        //   pathToTrack.indexOf(
        //     "ovl.longRunningProcessTracker.GENPrintDefChooserExecute.instance.Reklamation_8744_PDF_"
        //   ) > -1
        // ) {
        //   let yyy = 1
        //   debugger
        // }
        let rres = handleReactor(pathToTrack, value)
        if (rres?.cancel) {
          return false
        }
        if (rres?.newValue !== undefined) {
          value = rres.newValue
        }

        // we are not here yet...needed to remove because sometimes it's tracking as well inside actions
        // needs very deep investigation and maybe a base rewrite...
        // removed...@@todorenderingtrackingrework
        // if (!_RenderTracking.forceTracking && isTracking()) {
        //   target[key] = value
        //   return true
        // }
        target[key] = value

        if (!cumulatedPathsFromProxify.has(pathToTrack)) {
          // if (
          //   !isTracking() &&
          //   key !== "screenCounter" &&
          //   key !== "dialogCounter"
          // ) {
          //   // // console.log(key, value)
          //   // if (key === "isRunning" && value === false) {
          //   //   console.log(_RenderTracking.currentComponent)
          //   // }
          //   // console.log("bail out because of isTracking()")
          //   return true
          // }
          cumulatedPathsFromProxify.add(pathToTrack)
          //console.log(pathToTrack)
          // if (pathToTrack === "ovl.screens.nav") {
          //   console.trace()
          // }
          startScreenUpdate = true
        } else {
          //console.log("bail out because of already added")
        }

        if (startScreenUpdate) {
          StartScreenUpdate()
        }

        return true
      },

      deleteProperty(target, key) {
        if (Reflect.has(target, key)) {
          unproxy(target, key)
          let deleted = Reflect.deleteProperty(target, key)
          if (deleted /*&& !isTracking()*/) {
            let pathToTrack = [...path, key].join(".")

            if (!cumulatedPathsFromProxify.has(pathToTrack)) {
              cumulatedPathsFromProxify.add(pathToTrack)
              StartScreenUpdate()
            }
          }
          return deleted
        }
        return true
      },
    }
  }

  function unproxy(obj, key) {
    //ignore = true
    // if (JSON.stringify(obj).indexOf("OvlSysState") > -1) {
    //   debugger
    // }
    if (preproxy.has(obj[key])) {
      obj[key] = preproxy.get(obj[key])
      preproxy.delete(obj[key])
    }
    if (obj[key]) {
      for (let k of Object.keys(obj[key])) {
        if (typeof obj[key][k] === "object") {
          unproxy(obj[key], k)
        }
      }
    }
    //ignore = false
  }

  function proxify(obj, path) {
    //ignore = true
    if (obj) {
      for (let key of Object.keys(obj)) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (!preproxy.has(obj[key])) {
            obj[key] = proxify(obj[key], [...path, key])
          }
        }
      }
      let p = new Proxy(obj, makeHandler(path))
      preproxy.set(p, obj)
      return p
    }
    //ignore = false
  }
  return proxify(target, [])
}
let debouncedScreenUpdate

export let StartScreenUpdate = async (debounceMS = 34) => {
  if (debounceMS === -1) {
    doScreenUpdates()
    return
  }

  if (debouncedScreenUpdate) {
    //console.log("debounce", debounceMS)
    clearTimeout(debouncedScreenUpdate)
  }

  debouncedScreenUpdate = setTimeout(async () => {
    await doScreenUpdates()
  }, debounceMS)
}

const doScreenUpdates = async () => {
  let updateCount = cumulatedPathsFromProxify.size
  if (updateCount > 0) {
    // we need to know if the screen is fading out
    // if the screen is fading out we don't need to update the screen
    // this helps as well if eg. a datasource is used on 2 screens. so if changing to screen 2 is manipulating the datasource we won't have any flickering thanks to that

    let trackingBlock = currentScreenAndDialog.screens.some((s) =>
      s.classList.contains("trackingBlock")
    )
    let componentsRendered = new WeakSet()
    let pathsIgnoredBecauseInScreenTransition = false
    for (let f of cumulatedPathsFromProxify) {
      //if a screen is fading out don't accept any updates besides dialogs
      if (trackingBlock && f.indexOf("ovl.screens.nav.dialogCounter") < 0) {
        pathsIgnoredBecauseInScreenTransition = true
        continue
      }
      // sample for testing paths
      // if (
      //   f.indexOf("ovl.forms.SYSTableRowEdit.trowQORQuickOrderDetails") > -1
      // ) {
      //   if (f.split(".").length === 3) {
      //     debugger
      //   }
      // }
      cumulatedPathsFromProxify.delete(f)

      let cbs = paths.get(f)

      if (cbs) {
        for (let k of cbs) {
          if (!componentsRendered.has(k)) {
            componentsRendered.add(k)
            // its important to check initialsed because in comp base init gets tracked and therefore could trigger itself
            // usecase hedin rpt table column favorites list (there are some lookups loaded when the favorite list initialises)
            if (k.isConnected && k._initialised) {
              // do not use await here...was causing sequence and tracking to wrong comp issues
              k.doRender()
              _RenderTracking.totalCompRendered++
            }
            k = null
          }
        }
      }
      cbs = null
    }
    if (pathsIgnoredBecauseInScreenTransition) {
      debouncedScreenUpdate = setTimeout(() => {
        doScreenUpdates()
      }, 17)
    }
  }
}
